export enum FieldDisplayContext {
  STANDARD = 'standard',
  DECLARATIONS = 'declarations',
}
